import * as React from 'react'

export const SvgStoreStatus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 8 8"
    width="8"
    height="8"
    fill="none"
    aria-hidden={true}
    {...props}
  >
    <circle cx="4" cy="4" r="4" fill={props.fill}></circle>
  </svg>
)

export default SvgStoreStatus
